import Button from '@mui/material/Button'
import Dialog, { DialogProps } from '@mui/material/Dialog'
import * as React from 'react'
import { DialogToolbar } from '../TopToolbar/DialogToolbar'
import { Transition } from './Transition'
import Stack from '@mui/material/Stack'

interface Props {
  open: boolean
  onClose: () => void
  closeButtonText?: string
  transitionDuration?: DialogProps['transitionDuration']
  children: React.ReactNode
}

export function FullScreenDialog(props: Props) {
  const {
    open,
    onClose,
    closeButtonText = 'Close',
    transitionDuration,
    children,
  } = props

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      transitionDuration={transitionDuration}
    >
      <DialogToolbar>
        <Stack justifyContent="center" display="flex">
          <Button
            style={{ height: '36px' }}
            variant="contained"
            color="secondary"
            onClick={onClose}
            data-test-id="close-full-screen-dialog-button"
          >
            {closeButtonText}
          </Button>
        </Stack>
      </DialogToolbar>

      {children}
    </Dialog>
  )
}
